import { useState } from "react";
import { Check, Eye, EyeOff, X } from "lucide-react";

export const QuizQuestion = ({ q, index, reveal, testid = "quiz" }) => {
  const [picked, setPicked] = useState(null);
  const answered = picked !== null;
  return (
    <li data-testid={`${testid}-question-${index}`}>
      <p className="font-bold mb-2">{index + 1}. {q.question}</p>
      <div className="flex flex-wrap gap-2">
        {q.options.map((o, j) => {
          const correct = j === q.answer_index;
          const show = reveal || answered;
          const cls = show && correct ? "border-emerald-500 bg-emerald-50 font-bold text-emerald-800"
            : answered && j === picked ? "border-red-400 bg-red-50 text-red-700 line-through"
            : "border-slate-200 bg-white hover:border-[#1E293B] hover:-translate-y-0.5";
          return (
            <button key={j} onClick={() => setPicked(j)} disabled={answered} data-testid={`${testid}-option-${index}-${j}`} aria-pressed={picked === j}
              className={`flex items-center gap-1.5 px-3.5 py-2 rounded-full text-sm border-2 transition-all duration-150 ${cls} ${answered ? "cursor-default" : ""}`}>
              {show && correct && <Check className="w-4 h-4" />}
              {answered && j === picked && !correct && <X className="w-4 h-4" />}
              {o}
            </button>
          );
        })}
      </div>
      {answered && (
        <p className={`text-sm font-bold mt-2 ${picked === q.answer_index ? "text-emerald-700" : "text-slate-600"}`} data-testid={`${testid}-feedback-${index}`}>
          {picked === q.answer_index ? "Correct — great job!" : `Not quite — the answer is "${q.options[q.answer_index]}".`}
        </p>
      )}
    </li>
  );
};

export const Quiz = ({ questions, testid = "quiz" }) => {
  const [reveal, setReveal] = useState(false);
  return (
    <div className="space-y-4">
      <ol className="space-y-4" data-testid={`${testid}-list`}>
        {questions.map((q, i) => <QuizQuestion key={`${i}-${q.question}`} q={q} index={i} reveal={reveal} testid={testid} />)}
      </ol>
      <button onClick={() => setReveal((r) => !r)} className="text-sm font-bold text-slate-500 hover:text-[#1E293B] flex items-center gap-1.5" data-testid={`${testid}-reveal-button`}>
        {reveal ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />} {reveal ? "Hide answers" : "Show answers (for grown-ups)"}
      </button>
    </div>
  );
};
